import HelpIcon from './component'

export default HelpIcon